import React from 'react'
import { Link } from 'react-router-dom'
import Breadcumb from '../../Breadcumb/Main'
import BgImg from '../../../assets/images/unity.jpg'

const Culture = () => {
    return (
        <>
            <Breadcumb Title="Our Culture" Breadcumb="CAREERS" BgImg={BgImg} Extra={{backgroundPosition: 'center center'}} />
            <section className="section-padding--top section-padding--bottom">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="section-title">
                                <p className="section-title__text">How we work</p>
                                <h2 className="section-title__title">One team across three countries</h2>
                            </div>
                            <div className="about-four__text" style={{marginBottom: 20}}>
                                We take pride in solving complex problems with very simple solutions — and that shapes
                                our culture as much as our work. We do not see IT solutions as ones and zeros, but as
                                the result of human effort aimed at making life easier and better for people. That
                                keeps us humble, curious, and focused on what actually matters.
                            </div>
                            <div className="about-four__text" style={{marginBottom: 30}}>
                                Though we span Wolverhampton, Malmö, and Accra, we work as one team: we win together
                                with our clients, learn from each other daily, and celebrate every remarkable impact
                                we make — together.
                            </div>
                            <ul className="service-details__caption__list" style={{marginBottom: 40}}>
                                <li>
                                    <i className="fa fa-check-circle"></i>
                                    Keep it simple — the best solution is the one people understand
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i>
                                    Be straightforward and transparent, with clients and with each other
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i>
                                    Share knowledge generously — every expert here is also a teacher
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i>
                                    Respect the balance between cost, time, and quality
                                </li>
                            </ul>
                            <Link to="/about" className="thm-btn" style={{marginRight: 20}}><span>About Us</span></Link>
                            <Link to="/careers" className="thm-btn"><span>Join the Team</span></Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Culture
